<button
  type="button"
  class="gap-2 flex flex-row w-[228px] content-center flex-wrap shrink-0 rounded-[4px] justify-start items-start p-3 bg-white shadow-sm relative cursor-pointer transition-shadow participant-card shadow-xl focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[#5BA5F54D]"  [style.border-bottom]="'4px solid ' + getStatusBorderColor()"
  (click)="onCardClick()"
  (keydown)="handleCardKeyDown($event)"
  [attr.aria-label]="'Participant card for ' + participant.name">
  <div class="flex flex-col shrink-0 rounded-full justify-center items-center bg-[#D0D1D4] w-10 h-10">
    <span class="w-10 h-10 shrink-0 justify-center items-center text-white text-center font-medium font-[Archivo] text-xl leading-8 flex">
      {{ getInitials(participant.name) }}
    </span>
  </div>
  <div class="flex flex-col w-full shrink-0 justify-start items-start grow basis-0 max-w-[190px] overflow-hidden text-ellipsis">
    <span class="w-full shrink-0 justify-start items-start self-stretch text-black text-left font-weight-400 line-height-[29px] font-[Archivo] text-[20px] truncate inline-block leading-7  overflow-hidden text-nowrap whitespace-nowrap">
      {{ participant.name }}
    </span>
    <span class="w-full h-[22px] shrink-0 justify-start items-start  text-[#444955] text-left font-normal font-[Archivo] text-[14px] leading-snug">
      {{ secondaryLine }}
    </span>
  </div>
  <div *ngIf="participant.waitingListCount && participant.waitingListCount > 0 && (participant.status === 'waiting-list' || participant.status === 'delivered')"
       class="gap-0.5 flex flex-row h-[24px]  rounded-tl py-[4px] rounded-br shrink-0 justify-end items-center px-[6px] py-[4px] absolute right-0 left-3 top-10 bg-[#F26F24]">
    <NiIcon icon="schedule" class="w-[16px] h-[16px] text-white"></NiIcon>
    <span class="shrink-0 text-white text-center font-bold font-archivo text-[18px] leading-[18px]">
      {{ participant.waitingListCount }}
    </span>
  </div>
</button>

